module.exports = __webpack_public_path__ + "static/media/paperclip.06cba74d.svg";